import { render, staticRenderFns } from "./EmissaoNfse.vue?vue&type=template&id=5b31b00c&scoped=true&"
import script from "./EmissaoNfse.vue?vue&type=script&lang=js&"
export * from "./EmissaoNfse.vue?vue&type=script&lang=js&"
import style0 from "./EmissaoNfse.vue?vue&type=style&index=0&id=5b31b00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31b00c",
  null
  
)

export default component.exports